import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { SidenavComponent } from './sidenav.component';

const adminRoutes: Routes = [
  {
    path: '',
    component: SidenavComponent
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(adminRoutes)
  ],
  exports: [
    RouterModule
  ]
})
export class SidenavRoutingModule { }